import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { AnatomicalSideLabelPipe, BaseMaTableComponent } from '../../shared';


/**
* Table of Limb Length Discrepancy in deformity analysis.
*/
@Component({
	selector: 'lld-table',
	templateUrl: './lld-table.component.html',
	imports: [
		NgbCollapseModule,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class LldTableComponent extends BaseMaTableComponent {

	isCollapsed = true;

}
